<template>  
<div> <!-- root element start -->
    <div class="container-fluid mt-2">

          <div class="row">
            <div class="col-sm-12 col-md-3">
                <div class="card border-0">
                  <div class="card-header h5 bg-transparent border-0">Options</div>
                  <div class="card-body">
                      <ul class="list-group list-group-flush">
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('user-quote-list', '', '', '')">View Quote List</a>
                        <a href="#" class="list-group-item font-weight-bold" @click="changeRightView('create-quote', '', '', '')">Create a Quote</a>
                      </ul>
                  </div>
                </div>
            </div>
            <div class="col-sm-12 col-md-9">
              <component 
                :is="rightView" 
                :prop1="prop1" 
                :prop2="prop2" 
                :prop3="prop3" 
                @onSComplete="successComplete" 
                @onUComplete="unsuccessComplete"
                @onSecComplete="onSecondary"
              >
              </component>
            </div>
           </div>

    </div><!--  end container-fluid div -->
</div> <!-- root element end -->
</template>


<script>
import {store} from '../../stores/user-quote-main-store.js'

import userQuoteList from '../userQuotePageComponents/user-quote-list.vue'
import quoteCreate from '../utilityComponents/quoteComponents/quote-create.vue'
import viewQuote from '../utilityComponents/quoteComponents/quote-view.vue'
import emailQuote from '../utilityComponents/quoteComponents/quote-email.vue'

export default {
  store,
  props: ['quote'],
  data: function () {
    return { 

    }
  },
  computed: {
    rightView () { return this.$store.state.rightView },
    prop1 () { return this.$store.state.prop1 },
    prop2 () { return this.$store.state.prop2 },
    prop3 () { return this.$store.state.prop3 },
  },
  watch: {
    
  },
  mounted() {
    this.onOpen();
    this.getAllUserQuotes();
  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    getAllUserQuotes() { this.$store.dispatch("getAllUserQuotes"); },
    
    onOpen() {
      var _this = this;
      if(_this.quote == null || _this.quote == '' ) {
        _this.changeRightView('user-quote-list', '', '', '');
      } else {
        var setup = [_this.quote]
        _this.changeRightView('quote-view', '', '', setup);

      }
    },

    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'quote-save':
        _this.getAllUserQuotes();
        _this.changeRightView('user-quote-list', '', '', '');
        break;
        case 'quote-email':
        var setup = [value[1]]
          _this.changeRightView('quote-view', '', '', setup);
        break;
        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'quote-add':
          _this.changeRightView('user-quote-list', '', '', '');
        break;
        case 'quote-view':
          _this.changeRightView('user-quote-list', '', '', '');
        break;
        case 'quote-email':
          var setup = [value[1]]
          _this.changeRightView('quote-view', '', '', setup);
        break;
        default:
      }
    },
    onSecondary(value) {
      var _this = this;
      switch(value[0]) {
        case 'quote-view':
          var setup = [value[1]]
          _this.changeRightView('quote-view', '', '', setup);
        break;
        case 'quote-email':
          var setup = [value[1]]
          _this.changeRightView('quote-email', '', '', setup);
        break;

        default:
      }
    },

  },    
  components:{
  	'user-quote-list': userQuoteList,
    'create-quote': quoteCreate,
    'quote-view' : viewQuote,
    'quote-email' : emailQuote,
  },
  filters: {

  }
}
</script>
